
import React, { useState } from 'react';
import Button from '../base/Button';
import { useTranslation } from 'react-i18next';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
              {t('brand')}
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              {t('nav.home')}
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              {t('nav.services')}
            </button>
            <button 
              onClick={() => scrollToSection('cases')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              {t('nav.cases')}
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              {t('nav.testimonials')}
            </button>
            <button 
              onClick={() => scrollToSection('process')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              {t('nav.process')}
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              {t('nav.contact')}
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-3">
            <div className="flex items-center">
              <select
                value={i18n.language.startsWith('zh') ? 'zh-CN' : 'en'}
                onChange={(e) => i18n.changeLanguage(e.target.value)}
                className="border border-gray-300 rounded-lg px-2 py-1 text-sm text-gray-700 hover:border-gray-400 focus:outline-none cursor-pointer"
              >
                <option value="zh-CN">{t('lang.zh')}</option>
                <option value="en">{t('lang.en')}</option>
              </select>
            </div>
            <Button 
              onClick={() => scrollToSection('contact')}
              variant="primary"
            >
              {t('cta.freeConsult')}
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <div className="flex flex-col space-y-3 pt-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                {t('nav.home')}
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                {t('nav.services')}
              </button>
              <button 
                onClick={() => scrollToSection('cases')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                {t('nav.cases')}
              </button>
              <button 
                onClick={() => scrollToSection('testimonials')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                {t('nav.testimonials')}
              </button>
              <button 
                onClick={() => scrollToSection('process')}
                className="text-gray-700 hover:text-blue-600 transition-colors text左 cursor-pointer"
              >
                {t('nav.process')}
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                {t('nav.contact')}
              </button>
              <div className="pt-2 flex items-center gap-3">
                <select
                  value={i18n.language.startsWith('zh') ? 'zh-CN' : 'en'}
                  onChange={(e) => i18n.changeLanguage(e.target.value)}
                  className="border border-gray-300 rounded-lg px-2 py-1 text-sm text-gray-700 hover:border-gray-400 focus:outline-none cursor-pointer"
                >
                  <option value="zh-CN">{t('lang.zh')}</option>
                  <option value="en">{t('lang.en')}</option>
                </select>
                <Button 
                  onClick={() => scrollToSection('contact')}
                  variant="primary"
                  size="sm"
                >
                  {t('cta.freeConsult')}
                </Button>
              </div>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
